const r = {
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  }
}, n = {
  warning: "is-warning",
  success: "is-success",
  error: "is-error"
};
export {
  r as ICONS_STATUS,
  n as INPUT_STATUS
};
